import {ErrorOutline} from "@material-ui/icons";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import PropTypes from "prop-types";

const Error = ({
                   icon: Icon,
                   errorText
               }) => {
    return (
        <Box textAlign='center' width="100%" px={5}>
            <Box paddingBottom="1em">
                <Icon color="primary" style={{fontSize: '6rem'}}/>
            </Box>
            {!errorText ?
                <>
                    <Typography variant="h4">Qualcosa è andato storto</Typography>
                    <Typography variant="h5" color="textSecondary">Riprova più tardi</Typography>
                </> :
                <Typography variant="h5">{errorText}</Typography>}
            {/*<Typography variant="h5">È in corso la Mobile Number Portability richiesta, potrai accedere al dettaglio SIM a portabilità avvenuta</Typography>*/}
        </Box>
    )
}

Error.propTypes = {
    icon: PropTypes.object,
    errorText: PropTypes.string
}

Error.defaultProps = {
    icon: ErrorOutline
}

export default Error;
